import '@ant-design/compatible/assets/index.css';
import React, { useContext, useEffect, useState } from 'react';
import {
  CopyOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  WarningTwoTone,
  LoadingOutlined,
} from '@ant-design/icons';
import Title from 'components/Title';
import { Form, Card, Col, Row, notification, Drawer, Spin, Modal } from 'antd';
import { ReadOutlined } from '@ant-design/icons';
import moment from 'moment';
import { groupBy, isNil, sumBy } from 'lodash';
import AssetCatalogModal from 'components/AssetCatalogModal';
import SimpleAssetModal from './SimpleAssetModal';
import { conElementToElement } from './conElementToElement';
import DF from 'DisplayFramework';
import { getFinContractById } from 'services/fincontract';
import Analysis from './Analysis';
import Decisions from './Decisions';
import AssetsTable from './AssetsTable';
import ThirdParties from './ThirdParties';
import ElementsTable from './ElementsTable';
import AdditionalInfos from './AdditionalInfos';
import GuaranteesTable from './GuaranteesTable';
import QuickSimulation from './QuickSimulation';
import InvoicingAndPayment from './InvoicingAndPayment';
import DocList from '../../Document/DocList';
import ContractManagers from './ContractManagers';
import TasksListPopover from '../../workflow/TasksListPopover';
import Button from 'components/Button';
import SaveButton from 'components/SaveButton';
import WizardTabs from 'components/WizardTabs';
import Accounting from 'components/Accounting/index';
import {
  getThirdPartyById,
  getThirdPartyRoleListByTpid,
} from 'services/thirdParty';
import {
  createProposal,
  getProposalById,
  updateProposal,
} from 'services/proposal';

import {
  unGroup,
  toDatePickerDate,
  shouldUpdateCompare,
  objectParValueToString,
  dateToString,
} from 'utils/utils2';
import SynthesList from 'pages/Configuration/ParSynthesObject/SynthesList';
import IActions from 'icons/IActions';
import { TpRoleToTp } from './TpRoleToTp';
import { useForm } from 'antd/lib/form/Form';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import { useQuery } from 'react-query';
import {
  getMyWizards,
  getTaskCheckEntity,
  initTaskCheckEntity,
} from 'services/workflow';
import ProposalModal from '../ProposalModal';
import ModalControllerNV from 'components/ModalControllerNV';
import { useTranslation } from 'react-i18next';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { AuthContext } from 'components/Auth/Auth';
import CheckModal from 'pages/workflow/CheckModal';
import PurchaseOrderListTable from 'pages/Purchase/PurchaseOrderDetail/PurchaseOrderListTable';
import FinModification from 'pages/FinModification';
import _ from 'lodash';
// import { getAssetCatalogByID } from 'services/assetconfig';

type PropDetailProps = {
  ctrid?: number;
  isCreate?: boolean;
  onCancel?: () => void;
  copy?: boolean;
  showAsModal?: boolean;
  phaseProp?: 'PROPOSAL' | 'PROD';
  setisvisible?: any;
  isModal?: boolean;
};

type verificationtest = { success: boolean; description: string };
const PropDetail = (props: PropDetailProps) => {
  const {
    ctrid,
    isCreate,
    showAsModal = false,
    phaseProp,
    copy = false,
    onCancel,
    setisvisible,
    isModal,
  } = props;

  const [form] = useForm();
  const history = useHistory();
  const { t } = useTranslation();
  const { isInspect } = useContext(AuthContext);

  const { id } = useParams<{
    id: string;
  }>();
  const search = useLocation().search;
  const phase = phaseProp ?? new URLSearchParams(search).get('phase');

  const antIcon = <LoadingOutlined style={{ fontSize: 35 }} spin />;

  const { data: wizData } = useQuery(['getMyWizards', 'PROPOSAL'], () =>
    getMyWizards({ entity: 'PROPOSAL' }).then((res) => res.data)
  );

  const getProposalId = () => {
    const idProp = ctrid ? ctrid : id;
    if (isNil(idProp)) {
      return;
    }
    return Number(idProp);
  };

  const ProposalPhase = (): 'PROPOSAL' | 'PROD' => {
    if (!phase) {
      return 'PROPOSAL';
    } else {
      return phase as 'PROPOSAL' | 'PROD';
    }
  };

  const [state, setState] = useState({
    load: getProposalId() === undefined ? false : true,
    ctrid: '',
    ctreference: '',
    clientname: '',
    firstAssetid: 0,
    visible: false,
    catalogModal: false,
    simpleAssetModal: false,
    visibledrawer: false,
    tpclient: false,
    prcode: '',
    propreference: '',
  });

  const closeSynthes = () => {
    setState({ ...state, visibledrawer: false });
  };
  const openDrawerSynthes = () => {
    setState({ ...state, visibledrawer: true });
  };

  const contractId = getProposalId();
  const ctPhase = ProposalPhase();
  const tabPosition = localStorage.getItem('tabposition') ?? 'left';

  const { data, refetch, isFetching } = usePropDetail(contractId, ctPhase);

  const [checklist, setChecklist] = useState<any[]>([]);
  const [tpList, settpList] = useState<any[]>();

  const [loadingBtn, setLoadingBtn] = useState<boolean>(false);

  const [DISPLAYControl, setDISPLAYControl] = useState<boolean>(false);

  useEffect(() => {
    if (data) {
      let tp = data?.thirdParties.find(
        (elem: any) => elem.tprolecode === 'CLIENT'
      );
      form.resetFields();
      const {
        FIN = [],
        SERV = [],
        FEES = [],
        COMM = [],
        FINSERV = [],
        //      } = groupBy(data.conElements || [], 'ctetype');
      } = groupBy(
        conElementToElement(data.conElements, data.offer) || [],
        'ctetype'
      );

      setChecklist([]);
      setState({
        ...state,
        clientname: data.clientname,
        ctreference: data.ctreference,
        load: !isNil(contractId)
          ? data.propreference !== ''
            ? false
            : true
          : false,
        prcode: data.prcode,
        propreference: data.propreference,
      });

      let ctinitenddate: any = '';

      try {
        ctinitenddate =
          data?.ctinitenddate !== null && String(data.ctinitenddate).length > 0
            ? dateToString(data.ctinitenddate)
            : dateToString(moment().format('YYYY-MM-DD'));
      } catch (error) {
        ctinitenddate = String(moment().format('YYYY-MM-DD'));
      }
      let conElements: any[] = data?.conElements;

      let _selectedCteId = 1;
      let _selectedElement: any = conElements?.find(
        (e: any) =>
          e.ctetype === 'FIN' &&
          (e.ctestatus === 'PREFIN' || e.ctestatus === 'ACTIVE')
      );

      if (_selectedElement !== undefined) {
        _selectedCteId = _selectedElement?.cteid;
      } else {
        let _elem: any[] = conElements?.filter((e: any) => e.ctetype === 'FIN');

        _selectedCteId = _.maxBy(_elem, 'cteid')?.cteid;
      }

      let assets: any[] = data.assets;

      if (data?.flagfleet) {
        assets = data.assets.map((asset: any) => {
          let listOfDurationMin: number[] = asset?.listrv?.map(
            (rv: any) => rv.monthsmin
          );
          let listOfDurationMax: number[] = asset?.listrv?.map(
            (rv: any) => rv.monthsmax
          );

          let _listDistinctDuration: number[] = _.uniq([
            ...listOfDurationMin,
            ...listOfDurationMax,
          ]);

          let marksDuration: { [key: number]: string } = {};

          _listDistinctDuration.forEach((e: number, index: number) => {
            let marks =
              localStorage.getItem('lancode') === 'EN' ? 'Months' : 'Mois';
            let key: number = e;
            let value: string = String(e) + marks;
            marksDuration[key] = value; // Add key-value pairs to the object
          });

          let listMarksMillageByDuration = _listDistinctDuration.map(
            (duration: number) => {
              let listMillageByDuration = asset.listrv.filter(
                (rv: any) =>
                  rv.monthsmin === duration || rv.monthsmax === duration
              );

              let listOfMillageMin: number[] = listMillageByDuration.map(
                (rv: any) => rv.mileagemin
              );
              let listOfMillageMax: number[] = listMillageByDuration.map(
                (rv: any) => rv.mileagemax
              );

              let _listDistinct: number[] = _.uniq([
                ...listOfMillageMin,
                ...listOfMillageMax,
              ]);

              let marks: { [key: number]: string } = {};

              _listDistinct.forEach((e: number, index: number) => {
                let key: number = e;
                let value: string = String(e) + 'Km';
                marks[key] = value; // Add key-value pairs to the object
              });

              return {
                duration,
                marks,
                minMillage: Math.min(..._listDistinct),
                maxMillage: Math.max(..._listDistinct),
              };
            }
          );

          let rvDurationDefault = Math.min(..._listDistinctDuration);

          let listMillageByDuration = asset.listrv.filter(
            (rv: any) =>
              rv.monthsmin === rvDurationDefault ||
              rv.monthsmax === rvDurationDefault
          );

          let listOfMillageMin: number[] = listMillageByDuration.map(
            (rv: any) => rv.mileagemin
          );
          let listOfMillageMax: number[] = listMillageByDuration.map(
            (rv: any) => rv.mileagemax
          );

          let _listDistinctMillage: number[] = _.uniq([
            ...listOfMillageMin,
            ...listOfMillageMax,
          ]);

          let rvamountByDurationAndMillage = asset.listrv.find(
            (i: any) => i.mileagemin === Math.min(..._listDistinctMillage)
          )?.rvamount;

          let assetcatalog = asset.assetCatalog;
          // if (
          //   asset.catalogid !== 0 &&
          //   asset.catalogid != null &&
          //   asset.assetCatalog == null
          // ) {
          //   // await getAssetcatalog()
          //   //assetcatalog =
          //   await getAssetCatalogByID({
          //     catalogid: asset.catalogid,
          //   }).then((response) => {
          //     if (response.code === '200') {
          //       assetcatalog = response?.data;
          //     } else {
          //       notification.error({
          //         message: response.message,
          //       });
          //     }
          //   });
          // }

          return {
            ...asset,
            durationList: _listDistinctDuration,
            marksDuration: marksDuration,
            listMarksMillageByDuration: listMarksMillageByDuration,
            rvDuration: Math.min(..._listDistinctDuration),
            rvamountByDuration: rvamountByDurationAndMillage,
            assetcatalog: assetcatalog,
          };
        });
      }


      form.setFieldsValue({
        ThirdParties: data?.thirdParties,
        flagmasterfacility: data.flagmasterfacility,
        flagasset: data?.flagasset,
        flagfleet:
          data?.flagfleet === undefined && data?.prcode === 'LLD'
            ? true
            : data?.flagfleet,
        flaguseassetgrossamount: data?.flaguseassetgrossamount,
        flagrealestate: data.flagrealestate,
        flagretailer: data.flagretailer ?? false,
        mfprcode: data.mfprcode,
        selectedElement: _selectedCteId,
        calid: conElements?.find((e: any) => e.ctetype === 'FIN')?.calid,
        assets: !copy
          ? assets
          : assets.map((e) => ({
              ...e,
              age: '',
              separatortype: '',
              wheeldrive: '',
              transmission: '',
              wheeltrack: '',
              lift: '',
              capacity: '',
              balersize: '',
              tankcapacity: '',
              rotorhours: '',
              totalbalers: '',
              country: '',
              kwhpower: '',
              kwhproduction: '',
              kwhdegradation: '',
              power: '',
              fiscalpower: '',
              engineno: '',
              weight: '',
              chassisno: '',
              plateno: '',
              registrationno: '',
              registrationdate: '',
              registrationcity: '',
              registrationname: '',
              firstregistrationdate: '',
              assetmodel: '',
              assetconstructor: '',
              serialno: '',
              assetdescription: '',
            })),
        /* assets: data.assets.map((asset: any) => ({
            ...asset,
            assetusereqList: asset?.assetUseResponses?.map((use: any) => ({
              ...use,
            })),
          })),*/
        brid: data.brid,
        borrower: {
          tpid: data.tpidcoborrower,
        },
        broker: {
          tpidbroker: data.tpidbroker,
          brokername: data.brokername,
          brokerreference: data.brokerreference,
        },

        ctchannelcode: data?.ctchannelcode ?? '',
          // data.tpidbroker === null ? data.channelcode : ('' as any),
        ctnetworkcode: data?.ctnetworkcode ?? '',
          // data.tpidbroker !== null ? data.ctnetworkcode : ('' as any),

        ctsaleuserid:
          data.tpidbroker !== null ? ('' as any) : data.ctsaleuserid,
        vendorid: data.tpidbroker === null ? ('' as any) : data.ctsaleuserid,
        client: {
          tpid: data.tpidclient,
          tpname: data.clientname,
          tpreference: data.clientreference,
        },
        ctcomment: data?.ctcomment,
        ctvaliditydate: data?.ctvaliditydate,
        ctsignaturedate: data?.ctsignaturedate,
        ctacceptancedate:
          data?.ctacceptancedate ??
          data?.ctdecisioncodelabel + ' - ' + (data?.ctdecisiondate ?? ''),
        ctactivationdate: data.ctactivationdate,
        ctbankname: data.ctbankname,
        ctbic: data.ctbic,
        ctbillingdate: data.ctbillingdate,
        ctcbdate: data.ctcbdate,
        ctcbkey: data.ctcbkey,
        ctcbname: data.ctcbname,
        ctcbnum: data.ctcbnum,
        ctcbtype: data.ctcbtype,
        ctdeliverydate: data.ctdeliverydate,
        ctdescription: data.ctdescription,
        ctenddate: data.ctenddate,
        ctfinancedamount: data.ctfinancedamount,
        ctflagreminder: data.ctflagreminder,
        ctiban: data.ctiban,
        ctidautorization: data.ctidautorization,
        assetpictureurl: data.assetpictureurl,

        ctinvoiceaddresscity: data.ctinvoiceaddresscity,
        ctinvoiceaddressregion: data.tpinvoiceaddressregion,
        ctinvoiceaddressname: data.ctinvoiceaddressname,
        ctinvoiceaddressstr1: data.ctinvoiceaddressstr1,
        ctinvoiceaddressstr2: data.ctinvoiceaddressstr2,
        ctinvoiceaddresszipcode: data.ctinvoiceaddresszipcode,
        tpinvoiceaddresscountry:
          data?.thirdParties[0]?.address?.tpmainadrcountrylabel,
        ctinvoicesendingmode: data.ctinvoicesendingmode,
        ctmodificationfeesformula: data.ctmodificationfeesformula,
        ctinvoicingmode: data.ctinvoicingmode,
        ctpartialpayoffformula: data.ctpartialpayoffformula,
        ctlateinterestformula: data.ctlateinterestformula,
        cttotalpayoffformula: data.cttotalpayoffformula,
        ctdegradationfeesformula: data.ctdegradationfeesformula,
        ctorderdate: data.ctorderdate,
        ctpaymentdelay:
          data.ctpaymentdelay !== null ? data.ctpaymentdelay : tp?.tppaydelayin,
        ctpaymentmode:
          data.ctpaymentmode !== null ? data.ctpaymentmode : tp?.tppaymodein,

        propreference: data.propreference,
        ctreference: data.ctreference,
        currcode: data.currcode,
        ctstatuslabel:
          data.ctstatuslabel +
          ' (' +
          data.ctstatusdate +
          ')' +
          (data.ctreversalreasonlabel !== null &&
          data.ctreversalreasonlabel !== undefined &&
          data.ctreversalreasonlabel !== ''
            ? ' - ' + data.ctreversalreasonlabel
            : ''),
        ctrequestdate:
          data.ctrequestdate !== null && String(data.ctrequestdate).length > 0
            ? toDatePickerDate(data.ctrequestdate)
            : String(moment().format('YYYY-MM-DD')),
        ctinitstartdate:
          data.ctinitstartdate !== null &&
          String(data.ctinitstartdate).length > 0
            ? toDatePickerDate(data.ctinitstartdate)
            : toDatePickerDate(
                moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD')
              ),
        ctinitenddate: ctinitenddate,

        ctdurationmonths: data.ctdurationmonths ?? 0,
        cttype: data.cttype,
        ctfclevel: data.ctfclevel,
        description: data.ctdescription,

        elements: {
          COMM,
          FEES,
          FIN,
          FINSERV,
          SERV,
        },

        guarantor: {
          tpid: data.tpidguarantor,
          tpname: data.guarantorname,
          tpreference: data.guarantorreference,
        },

        prcode: data.prcode,
        flagspv: data.prcode === 'SPV',
        offerid: data.offerid,

        pricing: { ofrid: data.priid, ofrlabel: data.prilabel },
        pritype: data.pritype,
        supplier: {
          tpid: data.tpidsupplier,
          tpname: data.suppliername,
          tpreference: data.supplierreference,
        },
        tpnameCOB: data.cobname,
        tpreferenceCOB: data.cobreference,

        syndication:
          data?.syndication?.map((synd) => ({
            ...synd,
            partamount: data.ctfinancedamount * (Number(synd.partcoef) / 100),
            tpid: {
              tpid: synd.tpid,
              tpname: synd.partnername,
              tpreference: synd.partnerreference,
            },
          })) ?? [],
        syndlead: {
          tpid: data.tpidsyndlead,
          tpname: data.syndleadname,
          tpreference: data.syndleadreference,
        },

        ctsyndinvoicingtype: data.ctsyndinvoicingtype,
        ctsyndsuppliermanagementtype: data.ctsyndsuppliermanagementtype,
        ctsyndpaymentmanagementtype: data.ctsyndpaymentmanagementtype,
        ctsyndmgcoef: data.ctsyndmgcoef,
        ctsyndmgpartamount: data.ctsyndmgpartamount,
        thirdparties:
          data?.thirdParties?.map((e) => {
            if (e.tprolecode === 'MFBENEF') {
              return {
                ...e,
                mfrequestedamount:
                  e.mfrequestedamount === 0 || isNil(e.mfrequestedamount)
                    ? data.mfrequestedamount
                    : e.mfrequestedamount,
                tpid: {
                  tpid: e.tpid,
                  tpname: e.tpname,
                  tpreference: e.tpreference,
                },
                startdate: toDatePickerDate(e.startdate),
                enddate: toDatePickerDate(e.enddate),
              };
            } else
              return {
                ...e,
                tpid: {
                  tpid: e.tpid,
                  tpname: e.tpname,
                  tpreference: e.tpreference,
                },
                startdate: toDatePickerDate(e.startdate),
                enddate: toDatePickerDate(e.enddate),
              };
          }) ?? [],
        mfagreedamount: data.mfagreedamount,
        mfavailableamount: data.mfavailableamount,
        mfbookedamount: data.mfbookedamount,
        mfflagrevolving: data.mfflagrevolving,
        mfrequestedamount: data.mfrequestedamount,
        mfusedamount: data.mfusedamount,
        mfvaliditydate: data.mfvaliditydate,
        offerParams: data.offer,
        refetch: false,

        ctendofterm: data?.ctendofterm || null,
        ctendoftermtaskid: data?.ctendoftermtaskid || null,
        ctendoftermdelay: data?.ctendoftermdelay || null,
      });

      //1.	call “getTaskCheckEntity” (entity=PROPOSAL, entityid=ctrid, tasked=rvtaskid) 0 to 4 times, only when rvtaskid is not null, ratetaskid is not null,..

      if (
        data?.conElements[0]?.rvtaskid != null &&
        data?.conElements[0]?.rvtaskid !== 0
      ) {
        getTaskCheckEntity({
          entity: 'PROPOSAL',
          entityid: data?.ctrid,
          taskid: data?.conElements[0]?.rvtaskid,
        }).then((res) => {
          setChecklist([...checklist, res.list]);
        });
      }

      if (
        data?.conElements[0]?.ratetaskid != null &&
        data?.conElements[0]?.ratetaskid !== 0
      ) {
        getTaskCheckEntity({
          entity: 'PROPOSAL',
          entityid: data?.ctrid,
          taskid: data?.conElements[0]?.ratetaskid,
        }).then((res) => {
          setChecklist([...checklist, res.list]);
        });
      }

      if (
        data?.conElements[0]?.frtaskid !== null &&
        data?.conElements[0]?.frtaskid !== 0
      ) {
        getTaskCheckEntity({
          entity: 'PROPOSAL',
          entityid: data?.ctrid,
          taskid: data?.conElements[0]?.frtaskid,
        }).then((res) => {
          setChecklist([...checklist, res?.list]);
        });
      }

      if (
        data?.conElements[0]?.durationtaskid !== null &&
        data?.conElements[0]?.durationtaskid !== 0
      ) {
        getTaskCheckEntity({
          entity: 'PROPOSAL',
          entityid: data.ctrid,
          taskid: data.conElements[0]?.durationtaskid,
        }).then((res) => {
          setChecklist([...checklist, res.list]);
        });
      }
    } else {
      form.setFieldsValue({
        thirdparties: [],
        selectedElement: 1,
      });
    }
  }, [contractId, data]);

  const getControlTaskid = () => {
    let taskid = 0;
    data?.conElements.forEach((e) => {
      if (e.rvtaskid !== null && e.rvtaskid !== 0) taskid = e.rvtaskid;
      if (e.durationtaskid !== null && e.durationtaskid !== 0)
        taskid = e.durationtaskid;
      if (e.ratetaskid != null && e.ratetaskid !== 0) taskid = e.ratetaskid;
      if (e.frtaskid !== null && e.frtaskid !== 0) taskid = e.frtaskid;
      e?.conElemAttributes?.forEach((a) => {
        if (
          a.taskid !== 0 &&
          a.attstatus !== 'ACTIVE' &&
          a.attstatus !== 'ACCEPT' &&
          a.attstatus !== 'VALID'
        )
          taskid = a.taskid;
      });
    });
    return taskid;
  };

  const loadTPDetail = (
    tpid: any,
    tpname: any,
    tpreference: any,
    tprolecode: any
  ) => {
    if (tpid !== null && tpid !== '') {
      let tpdetail = {} as any;
      let alltp = tpList ?? [];
      let existTP = alltp.filter(
        (e: any) => e.tpid.tpid === tpid && e.tprolecode === tprolecode
      );

      if (existTP.length === 0) {
        return getThirdPartyById({ tpid: tpid }).then((response) => {
          if (response.code === '200') {
            tpdetail = response.data;
          }

          getThirdPartyRoleListByTpid({ tpid: tpid })
            .then((response) => {
              if (response.code !== '200') {
                notification.error({
                  message: response.message,
                  description: response.description,
                  duration: 0,
                });
              } else {
                if (response.list?.length !== 0 && response.list !== null) {
                  // api return 200 : exist role
                  // delete old CLIENT :
                  if (tprolecode === 'CLIENT') {
                    if (form.getFieldValue('flagmasterfacility') === true) {
                      alltp = alltp?.filter(
                        (tp: any) =>
                          tp?.tpid?.tpid !==
                          alltp?.find((tp: any) => tp.tprolecode === 'CLIENT')
                            ?.tpid?.tpid
                      );
                    }
                    alltp = alltp?.filter(
                      (e: any) => e.tprolecode !== 'CLIENT'
                    );
                  }

                  let roleData = response.list?.find(
                    (e) => e.tprolecode === tprolecode && e.status === 'VALID'
                  );

                  if (roleData === null && response?.list) {
                    roleData = response?.list[0];
                  }
                  let tpdata = TpRoleToTp(
                    tprolecode,
                    roleData,
                    tpname,
                    tpreference,
                    getProposalId()
                  );

                  alltp.push(tpdata);

                  let client = alltp?.find((e) => e.tprolecode === 'CLIENT');

                  if (
                    form.getFieldValue('prcode') === 'LEASEBACK' &&
                    (client === null || client === undefined) &&
                    tprolecode === 'SUPPLIER'
                  ) {
                    alltp.unshift(
                      TpRoleToTp(
                        'CLIENT',
                        roleData,
                        tpname,
                        tpreference,
                        getProposalId()
                      )
                    );
                  }

                  if (tprolecode === 'CLIENT') {
                    const username =
                      tpdetail?.generalData?.tpsurname !== null
                        ? tpdetail?.generalData?.tpsurname
                        : '';
                    form.setFieldsValue({
                      ctinvoiceaddressname:
                        tpdetail.generalData?.tpname + ' ' + username,
                      ctinvoiceaddressstr1: tpdetail?.address?.tpmainadrstreet1,
                      ctinvoiceaddressstr2: tpdetail?.address?.tpmainadrstreet2,
                      ctinvoiceaddresscity: tpdetail?.address?.tpmainadrcity,
                      ctinvoiceaddresszipcode:
                        roleData?.address?.tpmainadrzipcode,
                      ctinvoiceaddressregion:
                        tpdetail?.address?.tpmainadrregion,
                      ctpaymentdelay: roleData?.tppaydelayin,
                      ctpaymentmode: tpdetail?.role?.tppaymodein,
                      ctbankname: tpdetail?.bankAccount?.tpbankname,
                      ctiban: tpdetail?.bankAccount?.tpiban,
                      ctbic: tpdetail?.bankAccount?.tpbic,
                      ctflagreminder: true,
                      tpadrid: roleData?.tpadrid,
                      tpbkidin: roleData?.tpbkidin,
                      tpinvoiceaddresscountry:
                        roleData?.address?.tpmainadrcountry,
                    });

                    if (form.getFieldValue('flagmasterfacility') === true) {
                      alltp = alltp.filter(
                        (elem: any) => elem.tprolecode !== 'MFBENEF'
                      );
                      alltp.push(
                        TpRoleToTp(
                          'MFBENEF',
                          roleData,
                          tpname,
                          tpreference,
                          getProposalId()
                        )
                      );
                    }
                  }
                  form.setFieldsValue({ thirdparties: [] });
                  alltp = alltp.slice(); //thats will trigger the form
                  form.setFieldsValue({
                    thirdparties: alltp,
                  });
                }
              }
            })
            .catch((err) => {
              notification.error({ message: 'Error', description: err });
            });
        });
      }
    }
  };
  const { confirm } = Modal;

  const FonctionalTestVerification = (): verificationtest => {
    if (
      form
        .getFieldValue(['elements', 'FIN'])
        ?.find((ele: any) => ele.ctenominalrate < 0)
    )
      return { success: false, description: 'Nominal Rate is négative' };

    if (
      form
        .getFieldValue(['elements', 'FIN'])
        ?.find((ele: any) => ele.ctemarginrate < 0)
    )
      return { success: false, description: 'Margin Rate is négative' };

    if (
      form
        .getFieldValue(['elements', 'FIN'])
        ?.find((ele: any) =>
          ele.conElemSteps?.find(
            (step: any) =>
              step.status === 'ERRORROUT' ||
              step.status === 'ERRORRENT' ||
              step.status === 'ERROR'
          )
        ) !== undefined
    )
      return { success: false, description: 'Steps Required calculation' };

    if (
      form.getFieldValue('cttype') !== 'ALONE' &&
      form.getFieldValue('cttype') !== 'BUYBACK' &&
      sumBy(form.getFieldValue('syndication'), 'partcoef') +
        form.getFieldValue('ctsyndmgcoef') !==
        100
    )
      return { success: false, description: 'invalid Syndication coef' };

    return { success: true, description: '' };
  };

  const getName = (param: string, cteid: any) => {
    let lcteid = cteid ?? form.getFieldValue('selectedElement');

    if (lcteid === 1) {
      return ['elements', 'FIN', 0, param];
    } else {
      if (form.getFieldValue(['elements', 'FIN'])) {
        const index = form
          .getFieldValue(['elements', 'FIN'])
          .findIndex((item: any) => item.cteid === lcteid);
        return ['elements', 'FIN', index, param];
      } else {
        return ['elements', 'FIN', 0, param];
      }
    }
  };

  const onFinish = (values: any) => {
    // eslint-disable-next-line no-debugger
    // debugger;
    setLoadingBtn(true);

    let tp = data?.thirdParties.find(
      (elem: any) => elem.tprolecode === 'CLIENT'
    );
    const saveUpdate = (taskid: number) => {
      setState({ ...state, load: true });

      const toDateString = (momentOrString: any) =>
        momentOrString === undefined
          ? ''
          : typeof momentOrString === 'string'
          ? momentOrString
          : momentOrString.format('YYYY-MM-DD');

      const client = (form.getFieldValue('thirdparties') || []).find(
        (e: any) => e.tprolecode === 'CLIENT'
      );

      const header = {
        ctbankname:
          values?.ctbankname || client?.bankAccountIn?.tpbankname || null,
        ctiban: values?.ctiban || client?.bankAccountIn?.tpiban || null,
        ctbic: values?.ctbic || client?.bankAccountIn?.tpbic || null,
        ctflagreminder: true,
        tpadrid: values?.tpadrid ?? client?.address?.tpadrid ?? null,
        tpbkidin: values?.tpbkidin || client?.tpbkidin || null,
        brid: values.brid,
        ctsaleuserid: !isNil(values?.broker?.tpidbroker)
          ? values.vendorid
          : values?.ctsaleuserid,
        vendorid: values.vendorid ?? null,

        //ctacceptancedate: toDateString(values?.ctacceptancedate) || null,
        //ctactivationdate: toDateString(values?.ctactivationdate) || null,
        // ctbankname: values?.ctbankname || null,
        //ctbic: values?.ctbic || null,
        ctbillingdate: values?.ctbillingdate || null,
        //ctbouserdate: toDateString(values?.ctbouserdate) || null,
        //ctbouserid: values?.ctbouserid || null,
        ctcbdate: values?.ctcbdate || null,
        ctcbkey: values?.ctcbkey || null,
        ctcbname: values?.ctcbname || null,
        ctcbnum: values?.ctcbnum || null,
        ctcbtype: values?.ctcbtype || null,
        //ctdeliverydate: toDateString(values?.ctdeliverydate) || null,
        ctdescription: values?.ctdescription || null,
        //ctenddate: toDateString(values?.ctenddate) || null,
        ctfinancedamount: values?.ctfinancedamount || null,
        ctfree1: values?.ctfree1 || null,
        ctfree2: values?.ctfree2 || null,
        ctfree3: values?.ctfree3 || null,
        ctfree4: values?.ctfree4 || null,
        //ctiban: values?.ctiban || null,
        ctidautorization: values?.ctidautorization || null,
        ctinvoiceaddresscity: values?.ctinvoiceaddresscity || null,
        ctinvoiceaddressname: values?.ctinvoiceaddressname || null,
        ctinvoiceaddressstr1: values?.ctinvoiceaddressstr1 || null,
        ctinvoiceaddressstr2: values?.ctinvoiceaddressstr2 || null,
        ctinvoiceaddresszipcode: values?.ctinvoiceaddresszipcode || null,
        ctinvoicesendingmode: values?.ctinvoicesendingmode || null,
        tpinvoiceaddresscountry: values?.tpmainadrcountry || null,
        ctinvoicingmode: values?.ctinvoicingmode || null,
        ctspfeesformula: values?.ctspfeesformula || null,
        ctendofterm: values?.ctendofterm || null,
        ctendoftermtaskid: values?.ctendoftermtaskid || null,
        ctendoftermdelay: values?.ctendoftermdelay || null,
        ctlateinterestformula: values?.ctlateinterestformula?.priid || null,
        ctnetworkcode: values?.ctnetworkcode ?? null,
        // isNil(values?.broker?.tpidbroker)
        //   ? values.channelcode
        //   : values?.ctnetworkcode ?? null,
        ctchannelcode: values?.ctchannelcode ?? null,  
        ctpartialpayoffformula: values?.ctpartialpayoffformula?.priid || null,
        ctdegradationfeesformula:
          values?.ctdegradationfeesformula?.priid || null,
        ctmodificationfeesformula:
          values?.ctmodificationfeesformula?.priid || null,
        ctpaymentdelay:
          values?.ctpaymentdelay !== ''
            ? values?.ctpaymentdelay
            : tp?.tppaydelayin,
        ctpaymentmode:
          values?.ctpaymentmode !== ''
            ? values?.ctpaymentmode
            : tp?.tppaymodein,
        ctcomment: values?.ctcomment || null,
        ctrequestdate: toDateString(values?.ctrequestdate) || null,
        ctinitstartdate: toDateString(values?.ctinitstartdate) || null,
        flagfleet:
          form.getFieldValue('flagfleet') === true && values.prcode === 'LLD'
            ? true
            : false,
        ctdurationmonths:
          values.prcode !== 'WHOLESALE' || values.prcode !== 'WHSALEUSE'
            ? null
            : values.ctdurationmonths,
        ctinitenddate: toDateString(values?.ctinitenddate) || null,
        ctrid: values?.ctrid || null,
        cttotalpayoffformula: values?.cttotalpayoffformula?.priid || null,
        cttype: values?.cttype || 'ALONE',
        currcode: values.currcode,
        mcid: values?.mcid || null,
        offerid: values?.offerid || form.getFieldValue('offerid') || null,
        pricing: values?.pricing || form.getFieldValue('pricing') || null,
        prcode: values?.prcode || null,
        priid:
          values?.pricing?.ofrid ||
          form.getFieldValue('pricing')?.ofrid ||
          null,
        pritype:
          values?.pricing?.ofrtype || form.getFieldValue('pritype') || null,
        tpidbroker: values?.broker?.tpidbroker || null,
        tpidclient: values?.client?.tpid || null,
        clientname: values?.client?.tpname || null,
        clientreference: values?.client?.tpreference || null,
        tpidcoborrower: values?.borrower?.tpid || null,
        tpidguarantor: values?.guarantor?.tpid || null,
        tpidsupplier: values?.supplier?.tpid || null,
        catalogid: null,
        assetpictureurl: null,
        //typeof values?.supplier?.tpid === 'object'
        //? values?.supplier?.tpid.tpid
        //: values?.supplier?.tpid ?? null,
        tpinvoiceaddressregion: values?.ctinvoiceaddressregion || null,
        ctfclevel: values?.ctfclevel || null,
        tpidsyndlead: values?.syndlead?.tpid || null,
        ctsyndinvoicingtype: values?.ctsyndinvoicingtype || null,
        ctsyndsuppliermanagementtype:
          values?.ctsyndsuppliermanagementtype || null,
        ctsyndpaymentmanagementtype:
          values?.ctsyndpaymentmanagementtype || null,
        ctsyndmgcoef: values?.ctsyndmgcoef ?? null,
        ctsyndmgpartamount: values?.ctsyndmgpartamount ?? null,
        syndication:
          values?.syndication?.map((synd: any) => {
            return {
              ...synd,
              tpid: typeof synd.tpid === 'object' ? synd.tpid.tpid : synd.tpid,
            };
          }) ?? [],
        thirdParties: form.getFieldValue('thirdparties').map((e: any) => {
          return {
            ...e,
            tpid: typeof e.tpid === 'object' ? e.tpid.tpid : e.tpid,
          };
        }),
        mfagreedamount: values?.mfagreedamount,
        mfavailableamount: values?.mfavailableamount,
        mfbookedamount: values?.mfbookedamount,
        mfflagrevolving: values?.mfflagrevolving,
        mfrequestedamount: values?.mfrequestedamount,
        mfusedamount: values?.mfusedamount,
        mfvaliditydate: values?.mfvaliditydate,
        last_action:
          contractId && !copy
            ? wizData?.taskidUpdate ?? 0
            : wizData?.taskidCreate,
        ceilingrate: values.ceilingrate,
      };

      let ElemFIN = form.getFieldValue('elements') ?? [];

      const ELEMENTLIST = [
        ...(ElemFIN.FIN ?? []),
        ...(ElemFIN.SPV ?? []),
        ...(ElemFIN.FINOUT ?? []),
        ...(ElemFIN.FINSERV ?? []),
        ...(ElemFIN.SERV ?? []),
        ...(ElemFIN.SERVOUT ?? []),
        ...(ElemFIN.FEES ?? []),
        ...(ElemFIN.COMM ?? []),
      ]; //, ElemServ, ElemFinServ, ElemComm];

      const conElements = ELEMENTLIST.map((elem) => {
        const upFront = elem.cteupfrontamount;
        const partAmount =
          elem.ctepartmethod === 'PROMO' || elem.ctepartmethod === 'REDUCEFIN'
            ? elem.ctepartamount
            : 0;
        const investAmount = elem.ctefinancedamount + upFront + partAmount;

        const rvAmount = elem.ctetype === 'FIN' ? elem.ctervamount : 0;
        const firstPayment = elem.ctetype === 'FIN' ? elem.ctefirstpayment : 0;
        const rvCoef = (rvAmount / investAmount) * 100;

        const firstPaymentcoef = (firstPayment / investAmount) * 100;

        let lcteenddate = '';

        try {
          lcteenddate = form.getFieldValue('ctinitstartdate') ?? moment();
          var init = moment(
            dateToString(moment(elem.ctestartdate).format('YYYY-MM-DD'))
          );
          var target = init.add(elem.cteduration, 'M').subtract(1, 'd');

          lcteenddate = moment(target).format('YYYY-MM-DD');
        } catch (error) {
          lcteenddate = '';
        }

        let tpid = 0;

        if (
          elem.ctetype === 'FIN' ||
          elem.ctetype === 'FINSERV' ||
          elem.ctetype === 'SERV' ||
          elem.ctetype === 'FEES'
        ) {
          tpid = form.getFieldValue(['client', 'tpid']);
        } else {
          tpid = elem.tpid;
        }

        if (elem.ctetype === 'SERV' && elem?.servtype === 'RETAILER') {
          const assets = form.getFieldValue('assets');
          tpid = assets[0].tpidsupplier;
          if (elem.cteratetype === 'FLOAT') {
            elem.cteratespread = elem.ctenominalrate;
            elem.ctenominalrate = 0;
          }
        }

        return {
          cteid: elem.cteid,
          ctrid: copy ? 0 : elem.ctrid,
          cteorder: elem.cteorder,
          ctedirection: elem.ctedirection,
          ctetype: elem.ctetype,
          ctecategory: elem.ctecategory,
          ctestatus: elem.ctestatus,
          cteidparent: elem.cteidparent,
          tpid: tpid,
          priid: elem.priid === '' ? null : elem.priid,
          currcode: elem.currcode,
          taxcode: elem.taxcode,
          ctestartdate: moment(elem.ctestartdate).format('YYYY-MM-DD'),
          cteenddate: dateToString(elem.cteenddate),
          ctecalculationtype: elem.ctecalculationtype,
          ctecalculationbasis: elem.ctecalculationbasis,
          cteinitialamount: investAmount,
          cteupfrontamount: elem.cteupfrontamount,
          cteinvestamount: investAmount,
          ctefinancedamount: elem.ctefinancedamount,
          ctestartamount: investAmount,
          cteendamount: rvAmount,
          ctepaymentterm: elem.ctepaymentterm,
          cteinterestmethod: elem.cteinterestmethod,
          cteperiodicity: elem.cteperiodicity,
          cteduration: elem.cteduration,
          ctefirstpaymentdate: elem.ctefirstpaymentdate,
          ctedeferredinterestmethod: elem.ctedeferredinterestmethod,
          ctegraceperiodduration: elem.ctegraceperiodduration,
          ctegraceperiodmethod: elem.ctegraceperiodmethod,
          ctervcoef: Number(rvCoef.toFixed(5)),
          ctervamount: rvAmount,
          ctefirstpayment: firstPayment,
          ctefirstpaymentcoef: firstPaymentcoef,
          ctedepositamount: elem.ctedepositamount,
          ctedepositcoef: elem.ctedepositcoef,
          ctedepositinterestmethod: elem.ctedepositinterestmethod,
          ctedepositnominalrate: elem.ctedepositnominalrate,
          cteratetype: elem.cteratetype,
          cterateformula: elem.cterateformula,
          cterateterm: elem.cterateterm,
          cteratebasis: elem.cteratebasis,
          cterateperiodicity: elem.cterateperiodicity,
          cteactuarialrate: elem.cteactuarialrate,
          ctenominalrate: elem.ctenominalrate,
          cteratespread: elem.cteratespread,
          last_action: '',
          ctefree1: '',
          ctedeferredinterestnominalrate: elem.ctedeferredinterestnominalrate,
          cteinstallmentamount: elem.cteinstallmentamount,
          cteunit: elem.cteunit,
          ctedescription: elem.ctedescription,
          ctepartmethod: elem.ctepartmethod,
          ctepartamount: elem.ctepartamount,
          ctepartrate: elem.ctepartrate,
          ctepartdays: elem.ctepartdays,
          tpidparticipation: elem?.tpidparticipation?.tpid,
          ctepartratetype: elem.ctepartratetype,
          ctepartrateformula: elem.ctepartrateformula,
          ctepartinvoicingmode: elem.ctepartinvoicingmode,
          ctedeferredinterest: elem.ctedeferredinterest,
          ctedepositinterest: elem.ctedepositinterest,
          cterentalamount: elem.cterentalamount,
          ctebilligdate: elem.ctebilligdate,
          ctemileage: elem.ctemileage,
          ctepriidexceed: elem.ctepriidexceed?.priid,
          prefinmethod: elem.prefinmethod,
          prefinbasis: elem.prefinbasis,
          prefinperiodicity: elem.prefinperiodicity,
          prefinratetype: elem.prefinratetype,
          prefinrateformula: elem.prefinrateformula,
          prefinnominalrate: elem.prefinnominalrate,
          prefinrateref: elem.prefinrateref,
          ctepartratespread: elem.ctepartratespread,
          cterateref: elem.cterateref,
          rvcalculationmode: elem.rvcalculationmode,
          rvevaluationmode: elem.rvevaluationmode,
          additionalcostaftermargin: elem.additionalcostaftermargin,
          servfixedamount: elem.servfixedamount,
          servpercentage: elem.servpercentage,
          servbasis: elem.servbasis,
          marginoncalulatedcamount: elem.marginoncalulatedcamount,
          servtaskid: elem.servtaskid,
          servauthid: elem.servauthid,
          margintaskid: elem.margintaskid,
          marginauthid: elem.marginauthid,
          ctefeesamount: elem.ctefeesamount,
          ctecommissionamount: elem.ctecommissionamount,
          cteprofitabilityrate: elem.cteprofitabilityrate,
          cteaprrate: elem.cteaprrate,
          cteflatrate: elem.cteflatrate,
          ctecoefrate: elem.ctecoefrate,
          ctefundingrate: elem.ctefundingrate,
          ctefundingperiodicity: elem.ctefundingperiodicity,
          ctefundinginstallment: elem.ctefundinginstallment,
          ctefundingcost: elem.ctefundingcost,
          ctemarginamount: elem.ctemarginamount,
          ctemarginrate: elem.ctemarginrate,
          ctevatdeferralamount: elem.ctevatdeferralamount,
          ctevatdeferralduration: elem.ctevatdeferralduration,
          ctevatdeferralmethod: elem.ctevatdeferralmethod,
          ctevatdeferraldaysbasis: elem.ctevatdeferraldaysbasis,
          cteextracosttofinance: elem.cteextracosttofinance,
          cteextracostcomment: elem.cteextracostcomment,
          pritype: elem.pritype,
          ofrid: elem.ofrid,
          ofrlabel: elem.ofrlabel,
          ofrtype: elem.ofrtype,
          rvauthid: elem.rvauthid,
          rvtaskid: elem.rvtaskid,
          rateauthid: elem.rateauthid,
          ratetaskid: elem.ratetaskid,
          frauthid: elem.frauthid,
          frtaskid: elem.frtaskid,
          durationauthid: elem.durationauthid,
          durationtaskid: elem.durationtaskid,
          assetid: elem.assetid ?? 0,
          ceilingrate: elem.ceilingrate,
          ceilingdefaultrate: elem.ceilingdefaultrate,
          floorrate: elem.floorrate,
          floordefaultrate: elem.floordefaultrate,
          calid: form.getFieldValue('calid') ?? elem.calid,
          servuseunit: elem.servuseunit,
          servusefrequency: elem.servusefrequency,
          servuseqty: elem.servuseqty,
          servuseminamount: elem.servuseminamount,
          servusemaxamount: elem.servusemaxamount,
          servusecoverage: elem.servusecoverage,
          servusedeductionamount: elem.servusedeductionamount,
          servusedeductionpercenrage: elem.servusedeductionpercenrage,
          servdescription: elem.servdescription,

          conElemSchedules: elem.conElemSchedules?.map((sch: any) => {
            return {
              ctsid: null,
              ctesid: null,
              cteid: null,
              ctrid: null,
              ctsorder: sch.ctsorder,
              ctstype: sch.ctstype,
              ctsterm: sch.ctsterm,
              ctsperiodicity: sch.ctsperiodicity,
              ctsduedate: sch.ctsduedate,
              ctsstartdate: sch.ctsstartdate,
              ctsenddate: sch.ctsenddate,
              ctsactuarialrate: sch.ctseffectiverate,
              ctsstartamount: sch.ctsstartamount,
              ctsamortizedamount: sch.ctsamortizedamount,
              ctsinterestamount: sch.ctsinterestamount,
              ctsrentalamount: sch.ctsrentalamount,
              ctsoutstandingamount: sch.ctsoutstandingamount,
              ctsbasisamount: sch.ctsbasisamount,
              ctsbasisrate: sch.ctsbasisrate,
              ciid: null,
              cilid: null,
              ctsstatus: 'TOINVOICE',
              ctsdepositbasis: sch.ctsdepositbasis,
              ctsdepositrate: sch.ctsdepositrate,
              ctsdepositinterest: sch.ctsdepositinterest,
              taxcode: sch.ctstaxcode,
            };
          }),

          conElemSteps: elem.conElemSteps?.map((step: any) => {
            return {
              ctesid: null,
              ctesorder: step.ctesorder,
              ctesyear: step.ctesyear,
              ctesperiodicity: step.ctesperiodicity,
              ctesperiodicityunit: step.ctesperiodicityunit,
              ctesduration: step.ctesduration,
              ctesamortizedcoef: step.ctesamortizedcoef,
              ctesoutstandingamount: step.ctesoutstandingamount,
              ctesrentalamount: step.ctesrentalamount,
              ctesrentalcoef: step.ctesrentalcoef,
            };
          }),
          conElemAttributes: elem.conElemAttributes?.map((e: any) => {
            return {
              cteattid: 0,
              attid: e.attid,
              atttype: e.atttype,
              tpid: e.tpid,
              tpname: e.tpname,
              tpreference: e.tpreference,
              tprole: e.tprole,
              attcode: e.attcode,
              attdirection: e.attdirection,
              attmethod: e.attmethod,
              attexternalreference: e.attexternalreference,
              attamountmethod: e.attamountmethod,
              attamount: e.attamount,
              attamountmax: e.attamountmax,
              attamountmin: e.attamountmin,
              attcoef: e.attcoef,
              attcoefmax: e.attcoefmax,
              attcoefmin: e.attcoefmin,
              attrate: e.attrate,
              attnbdays: e.attnbdays,
              flagaddmanual: e.flagaddmanual,
              flagupdate: e.flagupdate,
              flagdelete: e.flagdelete,
              requesttype: e.requesttype,
              requestreceivertype: e.requestreceivertype,
              requestreceiverroleprofile: e.requestreceiverroleprofile,
              requestreceiverid: e.requestreceiverid,
              proccode: e.proccode,
              taskid: e.taskid,
              proctaskid: 0,
              attstatus: e.attstatus,
              nbmonthsmax: e.nbmonthsmax,
              nbmonthsdefault: e.nbmonthsdefault,
              nbmonthsrequested: e.nbmonthsrequested,
              attamountrequested: e.attamountrequested,
              attamountagreed: e.attamountagreed,
              attcomment: e.attcomment,
              attlabel: e.attlabel,
            };
          }),
          conElemServiceSteps: elem.serviceStepList?.map((step: any) => {
            return {
              ctesid: step.stepid,
              steporder: step.steporder,
              servcode: step.servcode,
              assettype: step.assettype,
              assetcategory: step.assetcategory,
              stepunit: step.stepunit,
              stepduration: step.stepduration,
              deprpercentage: step.deprpercentage,
              servpercentage: step.servpercentage,
              servamount: step.servamount,
            };
          }),
          conElemAssets: [],
          conElemPrefinSteps: elem?.conElemPrefinSteps,
          pricing: elem.pricing,
        };
      });

      const assets = form.getFieldValue('assets').map((asset: any) => {
        if (asset.catalogid !== null) {
          header.catalogid = asset.catalogid;
        }

        console.log('asset', asset);
        if (asset.assetpictureurl !== null) {
          header.assetpictureurl = asset.assetpictureurl;
        }
        const newAssetid = Math.floor(_.random(10000) * 10000);

        let assetusereqList: any[] = asset?.assetusereqList ?? [];

        let elem = ElemFIN?.FIN?.find(
          (elem: any) => elem.cteid === asset.cteid
        );

        console.log('ctemileage', elem);

        if (values.flagfleet || values.prcode === 'LLD') {
          assetusereqList.push({
            assetid: null,
            catalogid: asset?.catalogid,
            condid: null,
            useid: null,
            // uselabel: 'kilometreage',
            useunittype: 'KW',
            useunitperiod: 'YEAR',
            usevaluetype: null,
            minvalue: null,
            maxvalue: null,
            defaultvalue: 0,
            usevalue: elem?.ctemileage,
            attcode: 'KILOM',
            usereqreceivertype: null,
            priidexceed: elem?.ctepriidexceed?.priid,
            priidexceedlabel: null,
            // useunittypelabel: 'kilometers',
            // useunitperiodlabel: 'Yearly',
          });
        }
        console.log('assetusereqList:::', assetusereqList);
        console.log('les elements::', ELEMENTLIST[0]);
        return {
          assetServiceList: asset?.assetServiceList ?? [],
          assetusereqList: elem?.ctemileage?.priid
            ? assetusereqList
            : asset?.assetusereqList ?? [],
          entityAddAttributList: asset?.entityAddAttributList ?? [],
          assetComponents: copy
            ? asset?.assetComponents
              ? asset?.assetComponents?.map((Comp: any) => {
                  const newCompid = Math.floor(_.random(10000) * 1000);

                  return {
                    ...Comp,
                    compid: newCompid,
                    assetid: newAssetid,
                  };
                })
              : []
            : asset.assetComponents,
          irvSchedule: asset.irvSchedule,
          cteid: asset.cteid,
          assetid: copy ? newAssetid : asset.assetid,
          catalogid: asset.catalogid,
          assetpictureurl: asset.assetpictureurl,
          assetreference: copy ? null : asset.assetreference,
          assetstatus: asset.assetstatus,
          assetclass: asset.assetclass,
          assetphase: asset.assetphase,
          tpidsupplier:
            values.prcode === 'LLD'
              ? values?.supplier?.tpid
              : asset.tpidsupplier,
          suppliername: asset.suppliername,
          supplierreference: asset.supplierreference,
          tpidmanufacturer: asset.tpidmanufacturer,
          manufacturername: asset.manufacturername,
          manufacturerreference: asset.manufacturerreference,
          prcode: values?.prcode,
          assetsegment: objectParValueToString(asset?.assetsegment),
          assetfamily: objectParValueToString(asset?.assetfamily),
          assettype: objectParValueToString(asset?.assettype),
          assetcategory: objectParValueToString(asset?.assetcategory),
          assetmulticomponents: asset.assetmulticomponents,
          assetdescription:
            asset.assetdescription !== ''
              ? asset.assetdescription
              : asset.assetlabel,
          assetlabel: asset.assetlabel,
          assetorderdate: copy ? null : asset.assetorderdate,
          assetorderreference: copy ? null : asset.assetorderreference,
          assetdeliverydate: copy ? null : asset.assetdeliverydate,
          assetdeliveryreference: asset.assetdeliveryreference,
          currcode: values.currcode,
          assetnetamount: asset.assetnetamount,
          taxcode: asset.taxcode,
          taxrate: asset.taxrate,
          assettaxamount: asset.assettaxamount,
          assetgrossamount: asset.assetgrossamount,
          assetmodel: asset.assetmodel,
          assetconstructor: asset.assetconstructor,
          plateno: asset.plateno,
          power: asset.power,
          weight: asset.weight,
          chassisno: asset.chassisno,
          engineno: asset.engineno,
          registrationno: asset.registrationno,
          serialno: asset.serialno,
          flagused: asset.flagused,
          fiscaldepreciationmethod: asset.fiscaldepreciationmethod,
          deliveryadrstreet1: asset.deliveryadrstreet1,
          deliveryadrstreet2: asset.deliveryadrstreet2,
          deliveryadrcity: asset.deliveryadrcity,
          deliveryadrzipcode: asset.deliveryadrzipcode,
          deliveryadrregion: asset.deliveryadrregion,
          deliveryadrcountry: asset.deliveryadrcountry,
          assetqty: asset.assetqty,
          assetunitnetamount: asset.assetunitnetamount,
          assetrvamount: asset.assetrvamount,
          kwhdegradation: asset.kwhdegradation,
          kwhpower: asset.kwhpower,
          kwhproduction: asset.kwhproduction,
          assetfinamount: asset.assetfinamount,
          networkcode: asset?.networkcode,
          tpidbroker: asset?.tpidbroker,
          degfeesformula: asset?.degfeesformula,
          spfeesformula: asset?.spfeesformula,
          tpofformula: asset?.tpofformula,
          flagholdback: asset?.flagholdback,
          holdbackpercentage: asset?.holdbackpercentage,
          holdbackamount: asset?.holdbackamount,
          holdbackbeleasenbdays: asset?.holdbackbeleasenbdays,
          holdbackbeleasedate: asset?.holdbackbeleasedate,
          registrationcity: asset?.registrationcity,
          registrationdate: asset?.registrationdate,
          registrationname: asset?.registrationname,
          firstregistrationdate: asset?.firstregistrationdate,
          rotorhours: asset?.rotorhours,
          separatortype: asset?.separatortype,
          nbcampaign: asset?.nbcampaign,
          lift: asset?.lift,
          fiscalpower: asset?.fiscalpower,
          country: asset?.country,
          balersize: asset?.balersize,
          capacity: asset?.capacity,
          age: asset?.age,
          tankcapacity: asset?.tankcapacity,
          threshinghours: asset?.threshinghours,
          totalbalers: asset?.totalbalers,
          totalhours: asset?.totalhours,
          transmission: asset?.transmission,
          wheeldrive: asset?.wheeldrive,
          wheeltrack: asset?.wheeltrack,
        };
      });

      const contract = { ...header, conElements, assets } as any;
      if (
        form.getFieldValue('flagfleet') === true &&
        values.prcode === 'LLD' &&
        assets.length === 0
      ) {
        notification.error({ message: 'You have to choose an asset' });
        setLoadingBtn(false);
        setState({ ...state, load: false });
      } else {
        if (isNil(contractId) || copy) {
          createProposal({ ctRequest: contract })
            .then((response) => {
              setLoadingBtn(false);
              if (response.code === '200') {
                if (taskid !== null && taskid !== 0) {
                  initTaskCheckEntity({
                    taskid: taskid,
                    entity: 'PROPOSAL',
                    entityid: response.data.ctrid,
                  }).then((res) => {
                    notification.success({ message: res.message });
                  });
                }
                notification.success({
                  message: 'Proposal created successfully',
                  description: '',
                  duration: 15,
                });
                isModal && setisvisible();
                isModal && form.resetFields();

                // run WF :
                // await :

                history.push(`/proposal/${response.data.ctrid}?phase=PROPOSAL`);
                copy && onCancel && onCancel();
              } else {
                // notification.error({
                //   message: 'Error when saving Proposal',
                //   description: response.description,
                //   duration: 10,
                // });
                isModal && form.resetFields();
              }
              setState({ ...state, load: false });
            })
            .catch((response) => {
              setLoadingBtn(false);

              // notification.error({
              //   message: 'Error when saving Proposal',
              //   description: response.description,
              //   duration: 10,
              // });
              isModal && form.resetFields();
              setState({ ...state, load: false });
            });
        } else {
          updateProposal({ ctRequest: contract, ctrid: contractId })
            .then((response) => {
              setLoadingBtn(false);

              if (response.code === '200') {
                if (taskid !== null && taskid !== 0) {
                  initTaskCheckEntity({
                    taskid: taskid,
                    entity: 'PROPOSAL',
                    entityid: response.data.ctrid,
                  }).then((res) => {
                    if (
                      res.code === '200' &&
                      res.list != null &&
                      res.list.length > 0
                    ) {
                      notification.success({ message: res.message });

                      setDISPLAYControl(true);
                    }
                  });
                }

                notification.success({
                  message: 'Proposal updated successfully',
                  description: '',
                  duration: 15,
                });
                history.push(`/proposal/${response.data.ctrid}?phase=PROPOSAL`);
              } else {
                notification.error({
                  message: response.message,
                });
              }
              setState({ ...state, load: false });
            })
            .catch((response) => {
              setLoadingBtn(false);

              // notification.error({
              //   message: 'Error when saving Proposal',
              //   description: response.description,
              //   duration: 10,
              // });
              setState({ ...state, load: false });
            });
        }
      }
    };

    const showConfirm = (taskid: number, message: Array<String>) => {
      confirm({
        width: 1000,
        style: { width: 800, top: 200, fontSize: 20 },

        title: (
          <div style={{ fontSize: 20, color: 'black' }}>
            {localStorage?.getItem('lancode') === 'FR'
              ? 'Certains attributs financiers dépassent vos limites autorisées.'
              : 'Some Financial Attributes are out of your authorized bounds.'}
          </div>
        ),
        icon: <ExclamationCircleOutlined />,
        content: (
          <div style={{ fontSize: 20, color: 'black' }}>
            <br></br>
            <ul>
              {message.map((m, index) => (
                <li key={index}>{m}</li>
              ))}
            </ul>
            <br></br>
            <br></br>
            <p>
              {localStorage?.getItem('lancode') === 'FR'
                ? 'Voulez-vous continuer ?'
                : 'Would you like to continue ?'}
            </p>
          </div>
        ),

        onOk() {
          saveUpdate(taskid); //
        },
        okText: 'Yes',
        cancelText: 'No',
        okType: 'primary',
        onCancel() {
          setLoadingBtn(false);
          return false;
        },
      });
      return false;
    };

    let ElemFIN = form.getFieldValue(['elements', 'FIN']) ?? [];

    let ElemFEES = form.getFieldValue(['elements', 'FEES']) ?? [];

    let checkRV = false;
    let taskid = 0;

    let checkMessage: Array<String> = [];

    let priid =
      typeof values.ctexeedfeesformula === 'object'
        ? values.ctexeedfeesformula?.priid
        : values.ctexeedfeesformula;

    if (
      priid !== undefined &&
      priid !== form.getFieldValue('offerParams')?.priidexeed
    ) {
      checkRV = true;
      taskid = form.getFieldValue('offerParams')?.priidexeedtaskid ?? 0;
      checkMessage.push(
        'Exceed fees formula changed : ' +
          form.getFieldValue('offerParams')?.priidexeedlabel
      );
    }

    ElemFEES?.forEach((e: any) => {
      if (e.servtaskid != null && e.servtaskid !== 0) {
        if (e.ctecalculationbasis === 'FIXED') {
          if (e.servfixedamount < e.helpers?.servcontextmin) {
            checkRV = true;
            taskid = e.servtaskid;
            checkMessage.push(
              'Fees changed : entered ' +
                e.servfixedamount +
                ' Authorized : ' +
                e.helpers?.servcontextmin
            );
          }
        } else {
          if (e.ctecalculationbasis === 'PERC') {
            if (e.servpercentage < e.helpers?.servcontextmin) {
              checkRV = true;
              taskid = e.servtaskid;
              checkMessage.push(
                'Fees changed : entered % ' +
                  e.servpercentage +
                  ' Authorized : ' +
                  e.helpers?.servcontextmin
              );
            }
          }
        }
      }
    });

    ElemFIN.forEach((e: any) => {
      e.conElemAttributes.forEach((a: any) => {
        if (a.taskid != null && a.taskid !== 0 && a.attstatus === 'REQVAL') {
          checkRV = true;
          taskid = a.taskid;
          checkMessage.push(
            'Subsidy ' +
              a.attcodelabel +
              ' changed : entered ' +
              a.attamount +
              ' Authorized : ' +
              a.attamountmax
          );
        }
      });

      if (
        e.rvtaskid != null &&
        e.rvtaskid !== 0 &&
        (e.ctervcoef < e.helpers?.rvcontextmin ||
          e.ctervcoef > e.helpers?.rvcontextmax)
      ) {
        checkRV = true;
        taskid = e.rvtaskid;
        localStorage?.getItem('lancode') === 'FR'
          ? checkMessage.push(
              'La valeur résiduelle a été modifiée: saisie ' +
                e.ctervcoef +
                ' Authorisé : [ ' +
                e.helpers?.rvcontextmin +
                ',' +
                e.helpers?.rvcontextmax +
                ']'
            )
          : checkMessage.push(
              'Residual value changed: entered ' +
                e.ctervcoef +
                ' Authorized : [ ' +
                e.helpers?.rvcontextmin +
                ',' +
                e.helpers?.rvcontextmax +
                ']'
            );
        //            checkMessage=checkMessage + "<br>" + "Residual value"
      }

      if (
        e.durationtaskid != null &&
        e.durationtaskid !== 0 &&
        (e.cteduration < e.helpers?.durationcontextmin ||
          e.cteduration > e.helpers?.durationcontextmax)
      ) {
        checkRV = true;
        taskid = e.durationtaskid;
        localStorage?.getItem('lancode') === 'FR'
          ? checkMessage.push(
              'La durée a été modifié: saisie ' +
                e.cteduration +
                ' Authorisé : [ ' +
                e.helpers?.durationcontextmin +
                ',' +
                e.helpers?.durationcontextmax +
                ']'
            )
          : checkMessage.push(
              'Duration value changed: entered ' +
                e.cteduration +
                ' Authorized : [ ' +
                e.helpers?.durationcontextmin +
                ',' +
                e.helpers?.durationcontextmax +
                ']'
            );
      }
      if (
        e.ratetaskid != null &&
        e.ratetaskid !== 0 &&
        (e.ctenominalrate < e.helpers?.ratecontextmin ||
          e.ctenominalrate > e.helpers?.ratecontextmax)
      ) {
        checkRV = true;
        taskid = e.ratetaskid;
        localStorage?.getItem('lancode') === 'FR'
          ? checkMessage.push(
              'La valeur du taux nominal a été modifiée : saisie ' +
                e.ctenominalrate +
                ' Authorisé : [ ' +
                e.helpers?.ratecontextmin +
                ',' +
                e.helpers?.ratecontextmax +
                ']'
            )
          : checkMessage.push(
              'Nominal Rate value changed : entered ' +
                e.ctenominalrate +
                'Authorized : [ ' +
                e.helpers?.ratecontextmin +
                ',' +
                e.helpers?.ratecontextmax +
                ']'
            );
      }
      if (
        e.frtaskid != null &&
        e.frtaskid !== 0 &&
        (e.ctefirstpaymentcoef < e.helpers?.frcontextmin ||
          e.ctefirstpaymentcoef > e.helpers?.frcontextmax)
      ) {
        checkRV = true;
        taskid = e.rvtaskid;
        checkMessage.push(
          'First payment value changed : entered ' +
            e.ctefirstpaymentcoef +
            ' Authorized : [' +
            e.helpers?.frcontextmin +
            ',' +
            e.helpers?.frcontextmax +
            ']'
        );
      }

      if (
        e.margintaskid != null &&
        e.margintaskid !== 0 &&
        (e.ctemarginrate < e.helpers?.margincontextmin ||
          e.ctemarginrate > e.helpers?.margincontextmax)
      ) {
        checkRV = true;
        taskid = e.margintaskid;
        checkMessage.push(
          'Margin value changed : entered ' +
            e.ctemarginrate +
            ' Authorized : [' +
            e.helpers?.margincontextmin +
            ',' +
            e.helpers?.margincontextmax +
            ']'
        );
      }
    });

    if (checkRV) {
      showConfirm(taskid, checkMessage); // reqquires confirm box
    } else {
      // rv is OK, so check if exists old list :
      if (checklist && checklist.length > 0) {
        saveUpdate(taskid);
      } else {
        saveUpdate(0);
      }
    }
  };

  const handleSaveElement = (updatedElement: any) => {
    const ctetype = updatedElement.ctetype;
    const elementsByCteType = form.getFieldValue('elements');
    const updatedElements = {
      ...elementsByCteType,
      [ctetype]: elementsByCteType[ctetype].map((elem: any) => {
        return elem.cteid === updatedElement.cteid ? updatedElement : elem;
      }),
    };

    form.setFieldsValue({
      elements: updatedElements,
    });
  };

  const tabSimul = (
    <div>
      {state.load === false ? (
        form &&
        state.load === false && (
          <QuickSimulation
            reftechProp={refetch}
            form={form}
            phase={ProposalPhase()}
            isProposalCreate={isNil(contractId)}
            firstAssetid={state.firstAssetid}
            ctrid={copy ? undefined : contractId}
            loadTPDetail={loadTPDetail}
            showAsModal={showAsModal}
            ctstatus={data?.ctstatus}
            setLoadingBtn={setLoadingBtn}
          />
        )
      ) : (
        <Spin
          style={{
            margin: 'auto',
            width: '100%',
            padding: '250px',
          }}
        />
      )}
    </div>
  );

  const tabThirdParties = (
    <ThirdParties
      form={form}
      isProposalCreate={isNil(contractId)}
      onChangeTplist={(list: any) => {
        settpList(list);
      }}
      reftech={refetch}
    />
  );

  const tabFinModification = (
    <FinModification
      ctrid={Number(contractId)}
      hideExtraAction
      hideCtreferenceFilters
      isTab
      refetchProp={isFetching}
    />
  );
  const tabAttributes = <InvoicingAndPayment form={form} />;
  const tabManagers = (
    <ContractManagers
      ctrid={contractId!}
      phase={ProposalPhase() === 'PROD' ? 'CONTRACT' : 'PROPOSAL'}
      refetchProp={isFetching}
    />
  );
  const tabAddionalInfo = <AdditionalInfos />;
  const tabCheckList = (
    <DocList
      objectid={Number(contractId)}
      objectname={data?.clientname ?? ''}
      objectreference={data?.propreference ?? ''}
      tpid={data?.tpidclient}
      objecttype="PROPOSAL"
      categorie="CHECK"
      refetchProp={isFetching}
      applyFilter
    />
  );

  const tabAsset = (
    <Card
      title={
        <GetLabel
          label="Assets"
          style={{ fontWeight: 'bold', paddingLeft: 15 }}
        />
      }
      className="p-13"
      style={{
        width: '100%',
        boxShadow:
          'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
      }}
      bordered
    >
      <Form.Item shouldUpdate={shouldUpdateCompare('assets')} noStyle>
        {({ getFieldValue }) => (
          <AssetsTable
            flagreal={Boolean(getFieldValue('flagrealestate'))}
            onSelect={() => {
              // todo
            }}
            assets={getFieldValue('assets')}
            onDelete={(asset) => {
              //todo
            }}
            onMoveToNewelement={(asset) => {
              //todo
            }}
            hideSaveBtnAsset
            // onAddFromCatalog={handleAddFromCatalog}
            // onCreateNewAsset={handleCreateNewAsset}
            ctfclevel={getFieldValue('ctfclevel')}
            phase={ctPhase}
            // onSave={handleSaveAsset}
            currcode={getFieldValue('currcode')}
          />
        )}
      </Form.Item>
    </Card>
  );

  const tabFinancing = (
    <Card
      title={
        <GetLabel
          label="finElement"
          style={{ fontWeight: 'bold', paddingLeft: 15 }}
        />
      }
      style={{
        width: '100%',
        boxShadow:
          'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
      }}
      bordered
      className="p-13"
    >
      <Form.Item shouldUpdate>
        {({ getFieldValue, getFieldsValue }) => {
          const elementsByType = getFieldValue('elements') ?? {};
          const elements = unGroup(elementsByType);
          const allFIN = elements.filter((ele: any) => ele.ctetype === 'FIN');
          const data = allFIN.map((ele: any) => {
            const linkedServices = elements.filter(
              (serv: any) => serv.cteidparent === ele.cteid
            );

            return {
              ...ele,
              children: linkedServices,
            };
          });
          return (
            <ElementsTable
              onDeleteElement={(elem) => {
                //todo
              }}
              flagretailer={getFieldValue('flagretailer') ?? false}
              offerid={form?.getFieldValue('offerid')}
              form={form}
              elements={data}
              currcode={getFieldValue('currcode')}
              contract={getFieldsValue()}
              onSave={handleSaveElement}
            />
          );
        }}
      </Form.Item>
    </Card>
  );

  const tabCTpuorder = (
    <Card
      title={
        <GetLabel
          label="PurchaseOrder"
          style={{ fontWeight: 'bold', paddingLeft: 15 }}
        />
      }
      style={{
        width: '100%',
        boxShadow:
          'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
      }}
      bordered
      className="p-13"
    >
      <PurchaseOrderListTable
        ctrid={data?.ctrid ?? 0}
        currcode={String(data?.assets?.map((a) => a?.currcode)) ?? ''}
        refetchProp={isFetching}
      />
    </Card>
  );

  const tabAnalysis = (
    <Analysis
      objectid={copy ? undefined : getProposalId()}
      refetchProp={isFetching}
    />
  );

  const tabGuaranty = (
    <GuaranteesTable
      ctrid={copy ? undefined : getProposalId()}
      currcode={form.getFieldValue('currcode') ?? data?.currcode}
      refetchProp={isFetching}
    />
  );

  const tabDecision = (
    <Decisions
      ctrid={copy ? undefined : getProposalId()}
      refetchProp={isFetching}
    />
  );

  const tabAccounting = (
    <Accounting objectid={getProposalId()!} objecttype="CONTRACT" />
  );

  const tabUpload = (
    <DocList
      objectid={copy ? undefined : getProposalId()}
      objecttype="PROPOSAL"
      objectname={data?.clientname ?? ''}
      objectreference={data?.propreference ?? ''}
      tpid={data?.tpidclient}
      hideCol
      categorie="DOC"
      entityValue={{
        tpid: data?.tpidclient,
        tpreference: data?.clientreference,
        tpname: data?.clientname,
      }}
      refetchProp={isFetching}
      applyFilter
    />
  );
  const actions = !showAsModal && !copy && (
    <Row gutter={2} justify="end">
      {/* {(!isCreate || isCreate === undefined) && ( */}
      {data && (
        <>
          <Button
            comcode="Controls"
            icon={
              <WarningTwoTone
                twoToneColor="#eb2f96"
                onClick={() => {
                  setDISPLAYControl(true);
                }}
              />
            }
            style={{ marginLeft: '10px', height: 52 }}
            onClick={() => {
              setDISPLAYControl(true);
            }}
          />

          <Button
            comcode="Synthesis"
            icon={
              <ReadOutlined
                twoToneColor="#eb2f96"
                onClick={() => {
                  openDrawerSynthes();
                }}
              />
            }
            style={{ marginLeft: '2px', height: 52 }}
            onClick={() => {
              if (!isInspect) openDrawerSynthes();
            }}
          />
          {/* <Col span={5}>
            <Button
              comcode="printOffer"
              icon={<PrinterTwoTone twoToneColor="#eb2f96" />}
              style={{ marginleft: '15px' }}
              onClick={(e) => {
                e.stopPropagation();
                openPrint(state.ctrid, 'Print');
              }}
            />
          </Col> */}

          <Form.Item shouldUpdate={() => true}>
            {({ getFieldValue, getFieldsValue, setFieldsValue }) => {
              return (
                <TasksListPopover
                  entityId={data?.ctrid}
                  tpid={data?.tpidclient}
                  entityReference={
                    ctPhase === 'PROPOSAL'
                      ? data?.propreference
                      : data?.ctreference
                  }
                  entityName={ctPhase === 'PROD' ? 'CONTRACT' : 'PROPOSAL'}
                  requestedamount={data?.ctfinancedamount}
                  currcode={data?.currcode}
                  title={
                    ctPhase === 'PROD'
                      ? data?.ctreference + ' - ' + data?.clientname
                      : data?.propreference + ' - ' + data?.clientname
                  }
                  clientName={data?.clientname}
                  onClose={refetch}
                  prcode={data?.prcode}
                >
                  <Button
                    comcode="actions"
                    style={{ width: isInspect ? 200 : 120, height: 52 }}
                    icon={<IActions />}
                  />
                </TasksListPopover>
              );
            }}
          </Form.Item>
          {!(ProposalPhase() === 'PROD') && (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <Button
                  comcode="copy"
                  style={{ width: isInspect ? 200 : 110, height: 52 }}
                  icon={
                    <CopyOutlined
                      twoToneColor="#000000"
                      onClick={() => {
                        setVisible(true);
                      }}
                    />
                  }
                  onClick={() => {
                    if (!isInspect) setVisible(true);
                  }}
                />
              )}
              modal={({ setVisible, visible }) => (
                <ProposalModal
                  ctrid={Number(getProposalId() ?? null)}
                  copy
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  onSuccess={() => setVisible(false)}
                  title={
                    <GetLabel
                      Inspectstyle={{ width: '30%' }}
                      label="CopyProposal"
                    />
                  }
                />
              )}
            />
          )}
        </>
      )}
      {ProposalPhase() !== 'PROD' && (
        <Col
          span={
            ctrid && data?.ctstatus === 'ACTIVE'
              ? 0
              : ctrid && data?.ctstatus !== 'ACTIVE'
              ? 4
              : 6
          }
        >
          {data?.ctstatus !== 'ACTIVE' && (
            <SaveButton
              loading={loadingBtn}
              htmlType="submit"
              comcode="save"
              custom={{ height: 52 }}
            />
          )}
        </Col>
      )}
    </Row>
  );
  const [bgColor, setBgColor] = useState('transparent');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setBgColor('#ffff'); // New color when scrolling
      } else {
        setBgColor('transparent'); // Original color
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <DF.Provider
      pagcode="contract"
      entity="PROPOSAL"
      entityid={contractId}
      additionalAttribute={{ entity: 'PROPOSAL' }}
    >
      <div>
        <Spin spinning={isFetching}>
          <Form
            layout="vertical"
            form={form}
            preserve
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            onValuesChange={(changedValues) => {
              if (changedValues.prcode) {
                form.setFieldsValue({
                  offerid: null,
                  pricing: null,
                  assets: [],
                  selectedAsset: null,
                  elements: [],
                });
              }

              if (changedValues.ctfclevel) {
                form.setFieldsValue({
                  offerid: null,
                  pricing: null,
                  assets: [],
                  selectedAsset: null,
                  elements: [],
                });
              }

              if (changedValues.client) {
                loadTPDetail(
                  changedValues.client?.tpid,
                  changedValues.client?.tpname,
                  changedValues.client?.tpreference,
                  'CLIENT'
                );
                setState({
                  ...state,
                  clientname: changedValues.client?.tpname ?? '',
                });
              }
              if (changedValues.supplier) {
                loadTPDetail(
                  changedValues.supplier.tpid,
                  changedValues.supplier.tpname,
                  changedValues.supplier.tpreference,
                  'SUPPLIER'
                );
              }
              if (changedValues.guarantor) {
                loadTPDetail(
                  changedValues.guarantor.tpid,
                  changedValues.guarantor.tpname,
                  changedValues.guarantor?.tpreference,
                  'GUAR'
                );
              }
              if (changedValues.borrower) {
                loadTPDetail(
                  changedValues.borrower.tpid,
                  changedValues.borrower.tpname,
                  changedValues.borrower.tpreference,
                  'BORROWER'
                );
              }
              if (changedValues.broker) {
                loadTPDetail(
                  changedValues.broker.tpid,
                  changedValues.broker.tpname,
                  changedValues.broker.tpreference,
                  'BROKER'
                );
              }
              /*              if (changedValues.offerid) {
                form.setFieldsValue({
                  pricing: null,
                });

                handleOfferChange(changedValues.offerid);
              }

              if (changedValues.pricing) {
                handlePricingChange(changedValues.pricing);
              }
              if (changedValues.elements) {
                
                debouncedCalculateNew();
              }
              if (changedValues.selectedAssetID) {
                 
                debouncedCalculateNew();

              }*/
            }}
          >
            <Row
              style={{
                top: '0px',
                backgroundColor: bgColor,
                position: 'sticky',
                fontSize: '14px',
                fontWeight: 'bold',
                zIndex: 6,
                padding: '5px 0px',
                margin: '0px -9px',
              }}
            >
              <Col span={isInspect ? 8 : 13}>
                {!isModal ||
                  (!showAsModal && (
                    <ArrowLeftOutlined
                      onClick={() => {
                        phase === 'PROD'
                          ? history.push(`/proposal?phase=PROD`)
                          : history.push(`/proposal`);
                      }}
                      style={{
                        float: 'left',
                        margin: '0px 5px',
                        fontSize: 'larger',
                      }}
                    />
                  ))}

                {!isNil(contractId) && !copy ? (
                  <div style={{ fontSize: 14 }}>
                    {phase === 'PROD' ? (
                      <Title
                        comcode={
                          'Contract  - ' +
                          state.ctreference +
                          ' - ' +
                          state.clientname
                        }
                        level={5}
                        style={{ fontSize: '14px', fontWeight: 'bold' }}
                      />
                    ) : (
                      <Title
                        comcode={
                          'Proposal  - ' +
                          state.propreference +
                          ' - ' +
                          state.clientname
                        }
                        level={5}
                        style={{ fontSize: '14px', fontWeight: 'bold' }}
                      />
                    )}
                  </div>
                ) : copy ? (
                  t(`proposal.copy`) +
                  ':  ' +
                  state.ctreference +
                  ' - ' +
                  state.clientname
                ) : (
                  // <Title
                  //   level={4}
                  //   Inspectstyle={{ width: '30%' }}
                  //   comcode='NewProposal'
                  // ></Title>
                  <div style={{ marginLeft: 3, paddingTop: 4 }}>
                    <h2>
                      <GetLabel label="NewProposal" />
                      &nbsp;&nbsp;
                      {state.clientname ?? ''}
                    </h2>
                  </div>
                )}
              </Col>
              <Col span={isInspect ? 16 : 11}>
                {tabPosition === 'left' ? actions : null}
                {copy && (
                  <Row justify="end">
                    <Col span={10}>
                      <SaveButton
                        htmlType="submit"
                        onClick={() => {}}
                        comcode="save"
                      />
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>

            <WizardTabs
              entity="PROPOSAL"
              entityid={getProposalId()}
              taskid={
                contractId
                  ? wizData?.taskidDisplay ?? 0
                  : wizData?.taskidCreate ?? 0
              }
              hiddenTabs={[
                isNil(contractId) ? 'tabUpload' : '',
                'tabGeneralData',
                state.prcode === 'LOAN' ? 'tabAsset' : '',
                phase === 'PROPOSAL' ? 'tabFinModification' : '',
              ]}
              tabs={{
                tabSimul: tabSimul,
                tabThirdParties: tabThirdParties,
                //tabGeneralData: tabGeneralData,
                tabAttributes: tabAttributes,
                tabAsset: tabAsset,
                tabFinancing: tabFinancing,
                tabManagers: tabManagers,
                tabAddionalInfo: tabAddionalInfo,
                tabCheckList: tabCheckList,
                tabAnalysis: tabAnalysis,
                tabDecision: tabDecision,
                tabGuaranty: tabGuaranty,
                tabAccounting: tabAccounting,
                tabUpload: tabUpload,
                tabCTpuorder: tabCTpuorder,
                tabFinModification: tabFinModification,
              }}
              tabBarExtraContent={tabPosition === 'top' ? actions : null}
            />
          </Form>
        </Spin>
      </div>
      <AssetCatalogModal
        onCancel={() => setState({ ...state, catalogModal: false })}
        onSelect={() => {
          //todo
        }}
        visible={state.catalogModal}
      />
      <SimpleAssetModal
        onAdd={() => {
          //todo
        }}
        flagreal={Boolean(form.getFieldValue('flagrealestate'))}
        onCancel={() => setState({ ...state, simpleAssetModal: false })}
        visible={state.simpleAssetModal}
      />
      <Drawer
        title={<GetLabel label="synthesliste" />}
        width={400}
        onClose={closeSynthes}
        visible={state.visibledrawer}
        destroyOnClose
        headerStyle={{ backgroundColor: '#00a896' }}
        bodyStyle={{ paddingBottom: 80, alignContent: 'center' }}
        style={{
          //position: 'absolute',
          right: '0px',
          bottom: '0px',
          width: '100%',
          padding: '10px 16px',
          //textAlign: 'right',
          //background: '#fff',
          //borderTop: '1px solid #e9e9e9',
        }}
      >
        <SynthesList
          objecttype={ctPhase === 'PROD' ? 'CONTRACT' : 'PROPOSAL'}
          objectid={contractId ?? 0}
          currcode={form.getFieldValue('currcode') ?? data?.currcode}
        />
      </Drawer>

      {getProposalId() && (
        <CheckModal
          entityId={data?.ctrid ?? 0}
          entity={ctPhase === 'PROD' ? 'CONTRACT' : 'PROPOSAL'}
          taskid={getControlTaskid()}
          checkid={0}
          visible={DISPLAYControl}
          title=""
          checksList={[]}
          onCancel={() => setDISPLAYControl(false)}
          onSuccess={() => setDISPLAYControl(false)}
        />
      )}
    </DF.Provider>
  );
};

const usePropDetail = (ctrid: any, ctPhase: string) => {
  const finContractQuery = useQuery(
    ['getFinContractById', ctrid],
    () =>
      getFinContractById({ ctrid: ctrid })
        .then((res) => {
          if (res.code === '403') {
            window.history.replaceState(null, '', '/403');
            window.location.reload();
          }
          return res.data;
        })
        .catch((err) => {
          notification.error({
            message: err?.error,
            duration: 5000,
            description: err?.message,
          });
        }),
    { enabled: !isNil(ctrid) && ctPhase === 'PROD', staleTime: 60 * 1000 * 5 }
  );
  const proposalQuery = useQuery(
    ['getProposalById', ctrid],
    () =>
      getProposalById({ ctrid: ctrid })
        .then((res) => {
          if (res.code === '403') {
            window.history.replaceState(null, '', '/403');
            window.location.reload();
          }
          return res.data;
        })
        .catch((err) => {
          notification.error({
            message: err?.error,
            duration: 5000,
            description: err?.message,
          });
        }),
    {
      enabled: !isNil(ctrid) && ctPhase === 'PROPOSAL',
      staleTime: 60 * 1000 * 5,
    }
  );
  return ctPhase === 'PROD' ? finContractQuery : proposalQuery;
};
export default PropDetail;
